import { OrderSummaryMetaType } from "@/types/orders"; //OrderSummaryType
import { OrdersMeta, OrderSummaryMetaTypeInterface } from "@/modules/orders/meta";
import { CardsOrdersInterface, OrderCardSummaryInterface } from "@/interface/business/order.interface";
import OrderCardSummary from "@/modules/orders/card";

export default class CardsOrders implements CardsOrdersInterface {
  static MODULE_NAME = "orders/managements";

  list: Array<OrderCardSummaryInterface> = [];
  count: number = 0;
  meta: OrderSummaryMetaTypeInterface;
  key: number = 1;

  constructor(orders: Array<OrderCardSummaryInterface>, count: number = 0, meta: OrderSummaryMetaType) {
    orders.map((order: OrderCardSummaryInterface) => {
      this.list.push(new OrderCardSummary(order));
    });

    this.count = count;
    this.meta = new OrdersMeta(meta);
  }
}
